import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request, sleep } from "@/js/http/http_request";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
export default {
  name: "PurchaseOrderFormSendDrawer",
  components: {
    Confirm: Confirm,
    MailTemplateForm: MailTemplateForm,
    MailTemplateModal: MailTemplateModal
  },
  data: function data() {
    return {
      drawerWidth: "45%",
      drawer: false,
      isStatelessDrawer: false,
      preventWarehouseNotification: false,
      currentStep: 1,
      steps: [{
        id: 1,
        key: "mail",
        title: "Send custom e-mail(s)",
        inf: "Select an email template and targets to inform stakeholders."
      }, {
        id: 2,
        key: "synthesis",
        title: "Synthesis",
        inf: "Review the information and send the purchase order."
      }],
      isCopyingToClipboard: false,
      panels: [],
      openedPanel: 0,
      isSyncing: false,
      isNeedingSync: false,
      isSavingAndSending: false,
      emailPlaceholders: {},
      emailTemplates: [],
      isDeletingTemplate: false,
      templateModalShown: false,
      editableTemplate: {},
      form: {
        emailTemplates: [{
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }]
      }
    };
  },
  props: {
    purchaseOrder: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    warehouse: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    supplier: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isCreatingNewPo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    },
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo;
        return !x.id || !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
      };
      if (this.form.emailTemplates.some(nullishPredicate)) return true;
      return false;
    }
  },
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.drawer = true;
              _context2.next = 3;
              return _this2.fetchRequiredData();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    close: function close() {
      var clean = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (clean) {
        this.form = {
          emailTemplates: [{
            id: 0,
            sendTo: [],
            files: [],
            mailHistories: []
          }]
        };
        this.currentStep = 1;
        this.openedPanel = 0;
        this.preventWarehouseNotification = false;
      }
      this.$emit("closed");
      this.drawer = false;
    },
    fetchRequiredData: function fetchRequiredData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.fetchEmailTemplates();
            case 2:
              if (_this3.isCreatingNewPo) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return _this3.fetchEmailPlaceholders();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this4 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this4.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    changePanel: function changePanel() {
      var _this5 = this;
      if (document.querySelector("#expansion-panel_".concat(this.openedPanel && this.openedPanel - 1))) {
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(_this5.openedPanel && _this5.openedPanel - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      }
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    newEmail: function newEmail() {
      var _this6 = this;
      this.form.emailTemplates = [].concat(_toConsumableArray(this.form.emailTemplates), [{
        id: 0,
        sendTo: [],
        files: [],
        mailHistories: []
      }]);
      this.$nextTick(function () {
        var i = _this6.form.emailTemplates.length - 1;
        _this6.openedPanel = i;
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(i && i - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      });
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this7;
              _context4.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to fetch email templates.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context4.sent;
              _this7.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this8 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this8.templateModalShown = false;
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplates.splice(this.openedPanel, 1, _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent)
      }));
    },
    newTemplate: function newTemplate() {
      var _this9 = this;
      this.$nextTick(function () {
        return _this9.templateModalShown = true;
      });
    },
    deleteTemplatePanel: function deleteTemplatePanel(index) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this10.$refs.confirm.open("Confirm", "Are you sure you want to delete the configuration of this e-mail?");
            case 2:
              isConfirmed = _context5.sent;
              if (isConfirmed) {
                _this10.form.emailTemplates.splice(index, 1);
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this11;
              _context6.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data;
                if ((_e$response$data = e.response.data) !== null && _e$response$data !== void 0 && _e$response$data.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this11.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this11.isNeedingSync = true;else _this11.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isConfirmed, _this, rest;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this12.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context7.sent;
              if (!isConfirmed) {
                _context7.next = 14;
                break;
              }
              _this12.isDeletingTemplate = true;
              _this = _this12;
              _context7.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to delete this template.", {
                  type: "error"
                });
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context7.next = 10;
              return _this12.fetchEmailTemplates();
            case 10:
              rest = _this12.form.emailTemplates.filter(function (x) {
                return x.id === templateId;
              });
              _this12.form.emailTemplates = _toConsumableArray(rest.length > 0 ? rest : [{
                id: 0,
                files: [],
                sendTo: [],
                mailHistories: []
              }]);
              _this12.editableTemplate = {};
              _this12.isDeletingTemplate = false;
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var response, sortedPlaceholders;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return request("/v1/mail/placeholders?purchaseOrderId=".concat(_this13.purchaseOrder.id), "get", null, true, "api");
            case 2:
              response = _context8.sent;
              if (response !== null && response !== void 0 && response.data) {
                _context8.next = 6;
                break;
              }
              _this13.emailPlaceholders = {};
              return _context8.abrupt("return");
            case 6:
              sortedPlaceholders = Object.entries(response.data).sort(function (a, b) {
                var _b$, _a$;
                return (((_b$ = b[1]) === null || _b$ === void 0 ? void 0 : _b$.length) || 0) - (((_a$ = a[1]) === null || _a$ === void 0 ? void 0 : _a$.length) || 0);
              }).reduce(function (acc, _ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];
                acc[key] = value;
                return acc;
              }, {});
              _this13.emailPlaceholders = sortedPlaceholders;
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    saveAndSend: function saveAndSend() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var isConfirmed, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this14.$refs.confirm.open("Saving", "Are you sure you want to save and send this purchase order?");
            case 2:
              isConfirmed = _context9.sent;
              if (!isConfirmed) {
                _context9.next = 18;
                break;
              }
              _this14.isSavingAndSending = true;
              _this14.isStatelessDrawer = true;
              data = _this14.mapTo(_objectSpread(_objectSpread({}, _this14.purchaseOrder), {}, {
                mustBeSent: _this14.preventWarehouseNotification ? false : true
              }));
              _this = _this14;
              _context9.next = 10;
              return request("/v1/purchase-orders", _this14.isCreatingNewPo ? "post" : "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the purchase order");
                handleErrorData(_this, errorData);
                _this.isSavingAndSending = false;
                _this.isStatelessDrawer = false;
                throw e;
              });
            case 10:
              response = _context9.sent;
              _context9.next = 13;
              return _this14.sendCustomEmails();
            case 13:
              _this14.$toasted.show("Saved successfully.", {
                type: "success"
              });
              _this14.$emit("saved", response);
              _this14.isSavingAndSending = false;
              _this14.isStatelessDrawer = false;
              _this14.close(true);
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    sendCustomEmails: function sendCustomEmails() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _loop, i;
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var template, formData, _this;
                return _regeneratorRuntime().wrap(function _loop$(_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                      template = _this15.form.emailTemplates[i];
                      template.templateId = template.id;
                      formData = new FormData();
                      Object.keys(template).forEach(function (key) {
                        return formData.append(key, template[key]);
                      });
                      template.files.forEach(function (x) {
                        formData.append("files", !x.blob ? x : new File([x.blob], x.id));
                      });
                      _this = _this15;
                      _context12.next = 8;
                      return request("/v1/mail/send", "post", formData, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
                        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                          while (1) switch (_context10.prev = _context10.next) {
                            case 0:
                              _this.isSuccessfulSending = _objectSpread(_objectSpread({}, _this.isSuccessfulSending), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                              _context10.next = 3;
                              return sleep(100);
                            case 3:
                            case "end":
                              return _context10.stop();
                          }
                        }, _callee10);
                      }))).catch(/*#__PURE__*/function () {
                        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
                          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                            while (1) switch (_context11.prev = _context11.next) {
                              case 0:
                                _this.hasFailedSending = true;
                                _this.failedCustomMails = _objectSpread(_objectSpread({}, _this.failedCustomMails), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                                _context11.next = 4;
                                return sleep(100);
                              case 4:
                              case "end":
                                return _context11.stop();
                            }
                          }, _callee11);
                        }));
                        return function (_x) {
                          return _ref4.apply(this, arguments);
                        };
                      }());
                    case 8:
                    case "end":
                      return _context12.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < _this15.form.emailTemplates.length)) {
                _context13.next = 7;
                break;
              }
              return _context13.delegateYield(_loop(i), "t0", 4);
            case 4:
              i++;
              _context13.next = 2;
              break;
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var selectedTemplate, current;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this16.isSyncing = true;
              _context14.next = 3;
              return _this16.fetchEmailTemplates();
            case 3:
              selectedTemplate = _this16.form.emailTemplates[_this16.openedPanel];
              if (!!selectedTemplate.id) {
                current = _this16.emailTemplates.find(function (x) {
                  return x.id === selectedTemplate.id;
                });
                _this16.changeTemplate(current);
              }
              _this16.isSyncing = false;
              _this16.isNeedingSync = false;
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }))();
    },
    mapTo: function mapTo(purchaseOrder) {
      return {
        id: purchaseOrder.id,
        isDraft: purchaseOrder.isDraft,
        commentary: purchaseOrder.commentary,
        isStoredAtSupplier: purchaseOrder.isStoredAtSupplier,
        isCloseConsignmentStocks: purchaseOrder.isCloseConsignmentStocks,
        reference: purchaseOrder.reference,
        creationDate: purchaseOrder.date,
        expectedDeliveryDate: purchaseOrder.expectedDeliveryDate,
        actualDeliveryDate: purchaseOrder.actualDeliveryDate,
        billDate: purchaseOrder.billDate,
        paymentDate: purchaseOrder.paymentDate,
        terms: purchaseOrder.termsId,
        supplierId: purchaseOrder.supplierId,
        producerAlternateStorageAddressId: purchaseOrder.producerAlternateStorageAddressId,
        warehouseId: purchaseOrder.warehouseId,
        items: purchaseOrder.items,
        mustBeSent: purchaseOrder.mustBeSent
      };
    }
  }
};